import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export default function AuthCallback() {
  const { status } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'authed') navigate('/', { replace: true });
    if (status === 'anon') navigate('/login', { replace: true });
  }, [status, navigate]);

  return (
    <div className="flex h-screen items-center justify-center bg-shell font-sans text-[13px] text-muted">
      Signing you in…
    </div>
  );
}
